module.exports = __webpack_public_path__ + "static/media/mail.56ba4078.svg";